// German city geocoding data for ride creation
export const CITY_COORDINATES = {
  'Hamburg': { lat: 53.5511, lng: 9.9937 },
  'Berlin': { lat: 52.5200, lng: 13.4050 },
  'München': { lat: 48.1351, lng: 11.5820 },
  'Köln': { lat: 50.9375, lng: 6.9603 },
  'Frankfurt': { lat: 50.1109, lng: 8.6821 },
  'Stuttgart': { lat: 48.7758, lng: 9.1829 },
  'Düsseldorf': { lat: 51.2277, lng: 6.7735 },
  'Dortmund': { lat: 51.5136, lng: 7.4653 },
  'Essen': { lat: 51.4556, lng: 7.0116 },
  'Leipzig': { lat: 51.3397, lng: 12.3731 },
  'Bremen': { lat: 53.0793, lng: 8.8017 },
  'Dresden': { lat: 51.0504, lng: 13.7373 },
  'Hannover': { lat: 52.3759, lng: 9.7320 },
  'Nürnberg': { lat: 49.4521, lng: 11.0767 },
  'Duisburg': { lat: 51.4344, lng: 6.7623 },
  'Bochum': { lat: 51.4818, lng: 7.2162 },
  'Wuppertal': { lat: 51.2562, lng: 7.1508 },
  'Bielefeld': { lat: 52.0302, lng: 8.5325 },
  'Bonn': { lat: 50.7374, lng: 7.0982 },
  'Münster': { lat: 51.9607, lng: 7.6261 },
  'Karlsruhe': { lat: 49.0069, lng: 8.4037 },
  'Mannheim': { lat: 49.4875, lng: 8.4660 },
  'Augsburg': { lat: 48.3705, lng: 10.8978 },
  'Wiesbaden': { lat: 50.0826, lng: 8.2400 },
  'Mönchengladbach': { lat: 51.1805, lng: 6.4428 },
  'Gelsenkirchen': { lat: 51.5177, lng: 7.0857 },
  'Aachen': { lat: 50.7753, lng: 6.0839 },
  'Braunschweig': { lat: 52.2689, lng: 10.5268 },
  'Kiel': { lat: 54.3233, lng: 10.1394 },
  'Chemnitz': { lat: 50.8278, lng: 12.9214 },
  'Halle': { lat: 51.4969, lng: 11.9688 },
  'Magdeburg': { lat: 52.1205, lng: 11.6276 },
  'Freiburg': { lat: 47.9990, lng: 7.8421 },
  'Krefeld': { lat: 51.3388, lng: 6.5853 },
  'Lübeck': { lat: 53.8655, lng: 10.6866 },
  'Oberhausen': { lat: 51.4697, lng: 6.8514 },
  'Erfurt': { lat: 50.9848, lng: 11.0299 },
  'Mainz': { lat: 49.9929, lng: 8.2473 },
  'Rostock': { lat: 54.0887, lng: 12.1427 },
  'Kassel': { lat: 51.3127, lng: 9.4797 },
  'Hagen': { lat: 51.3671, lng: 7.4633 },
  'Hamm': { lat: 51.6739, lng: 7.8150 },
  'Saarbrücken': { lat: 49.2401, lng: 6.9969 },
  'Mülheim': { lat: 51.4272, lng: 6.8825 },
  'Potsdam': { lat: 52.3906, lng: 13.0645 },
  'Ludwigshafen': { lat: 49.4774, lng: 8.4452 },
  'Oldenburg': { lat: 53.1435, lng: 8.2146 },
  'Leverkusen': { lat: 51.0459, lng: 7.0192 },
  'Osnabrück': { lat: 52.2799, lng: 8.0472 },
  'Solingen': { lat: 51.1652, lng: 7.0670 },
  'Heidelberg': { lat: 49.3988, lng: 8.6724 },
  'Herne': { lat: 51.5389, lng: 7.2256 },
  'Neuss': { lat: 51.2044, lng: 6.6850 },
  'Darmstadt': { lat: 49.8728, lng: 8.6512 },
  'Paderborn': { lat: 51.7189, lng: 8.7575 },
  'Regensburg': { lat: 49.0134, lng: 12.1016 },
  'Ingolstadt': { lat: 48.7665, lng: 11.4257 },
  'Würzburg': { lat: 49.7913, lng: 9.9534 },
  'Fürth': { lat: 49.4778, lng: 10.9897 },
  'Wolfsburg': { lat: 52.4227, lng: 10.7865 },
  'Offenbach': { lat: 50.1006, lng: 8.7761 },
  'Ulm': { lat: 48.4011, lng: 9.9876 },
  'Heilbronn': { lat: 49.1427, lng: 9.2109 },
  'Pforzheim': { lat: 48.8921, lng: 8.6945 },
  'Göttingen': { lat: 51.5412, lng: 9.9158 },
  'Bottrop': { lat: 51.5246, lng: 6.9285 },
  'Trier': { lat: 49.7490, lng: 6.6371 },
  'Recklinghausen': { lat: 51.6142, lng: 7.1980 },
  'Reutlingen': { lat: 48.4919, lng: 9.2044 },
  'Bremerhaven': { lat: 53.5396, lng: 8.5809 },
  'Koblenz': { lat: 50.3569, lng: 7.5890 },
  'Bergisch Gladbach': { lat: 50.9860, lng: 7.1298 },
  'Jena': { lat: 50.9272, lng: 11.5892 },
  'Remscheid': { lat: 51.1790, lng: 7.1896 },
  'Erlangen': { lat: 49.5897, lng: 11.0089 },
  'Moers': { lat: 51.4508, lng: 6.6268 },
  'Siegen': { lat: 50.8748, lng: 8.0243 },
  'Hildesheim': { lat: 52.1513, lng: 9.9517 },
  'Salzgitter': { lat: 52.1538, lng: 10.4126 }
};

export const getCoordinates = (cityName) => {
  const normalized = cityName.trim();
  
  if (CITY_COORDINATES[normalized]) return CITY_COORDINATES[normalized];
  
  const match = Object.keys(CITY_COORDINATES).find(city => 
    normalized.toLowerCase().includes(city.toLowerCase()) ||
    city.toLowerCase().includes(normalized.toLowerCase())
  );
  
  if (match) return CITY_COORDINATES[match];
  
  console.warn(`No coordinates for "${cityName}", using Hamburg as fallback`);
  return CITY_COORDINATES['Hamburg'];
};
